import { Box, Container, Rating } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Page from "components/Page";
import { useTranslation } from "react-i18next";

import { fDateTimeSuffix } from "@/utils/formatTime";

import Header from "./components/header";
import { useFeedbackList } from "./hooks/prpSessionFeedback.hook";

function renderRating(params: any) {
    return <Rating size="small" readOnly value={params.value} />;
}

const PrpSessionFeedbackPage = () => {
    const { t } = useTranslation();
    const { data, isLoading } = useFeedbackList();

    const columns = [
        { field: "sessionId", headerName: t("session_id"), flex: 1 },
        { field: "notes", headerName: t("notes"), flex: 2 },
        { field: "expertise", headerName: t("expertise"), flex: 1, renderCell: renderRating },
        { field: "satisfaction", headerName: t("satisfaction"), flex: 1, renderCell: renderRating },
        { field: "customerService", headerName: t("customer_service"), flex: 1, renderCell: renderRating },
        {
            field: "createdAt",
            headerName: t("date"),
            flex: 2,
            valueFormatter: (params: any) => {
                return fDateTimeSuffix(params.value);
            },
        },
    ];

    return (
        <Page title={t("feedbacks")}>
            <Container sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Header />
                <Box sx={{ height: 400, width: "100%" }}>
                    <DataGrid rows={Array.isArray(data) ? data : []} loading={isLoading} columns={columns} />
                </Box>
            </Container>
        </Page>
    );
};

export default PrpSessionFeedbackPage;
